import axios from "axios";
import { api } from "./api_route";

// Organization Master

export const allOrganization = async (values) => {
  try {
    const result = await axios.get(`${api}/organization/`);

    return result.data;
  } catch (error) {
    return [];
  }
};

export const organizationFilesDownload = async (values) => {
  try {
    const response = await axios.get(`${api}/documents/organizationFiles/${values}`, {
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    return [];
  }
};



export const createOrganization = async (values) => {
  try {
    const result = await axios.post(`${api}/organization/create`, { values });
    return result.data;
  } catch (error) {
    return [];
  }
};

export const updateOrganization = async (values) => {
  try {
    const result = await axios.post(`${api}/organization/update`, { values });
    return result.data;
  } catch (error) {
    return [];
  }
};

export const isActiveOrganization = async (values) => {
  try {
    const result = await axios.post(`${api}/organization/isActive`, { values });
    return result.data;
  } catch (error) {
    return [];
  }
};

export const deleteOrganization = async (values) => {
  try {
    const result = await axios.post(`${api}/organization/delete`, { values });
    return result.data;
  } catch (error) {
    return [];
  }
};

//Organization Document Upload and View Delete Option

export const getOrganizationDocuments = async (params = {}) => {
  try {
    const result = await axios.post(`${api}/organization/documentData`, params);
    return result.data;
  } catch (error) {
    return [];
  }
};

export const organizationUploadDocuments = async (values) => {
  try {
    var files = new FormData();

    values?.uploadedFiles?.map((document, i) => {
      files.append("file", document);
    });

    files.append("organization", JSON.stringify(values));
    const result = await axios.post(`${api}/organization/upload`, files);

    return result;
  } catch (error) {
    return [];
  }
};

export const organizationAwards = async (params = {}) => {
  try {
    const result = await axios.post(`${api}/organization/repositoryAwards`, params);
    return result.data;
  } catch (error) {
    return [];
  }
};

export const organizationDocumentIsActive = async (values) => {
  try {
    const result = await axios.post(
      `${api}/organization/isActiveDocument`,
      values
    );

    return result.data;
  } catch (error) {
    return [];
  }
};

export const updateOrganizationDocumentStatus = async (values) => {
  try {
    const result = await axios.post(
      `${api}/organization/updateOrganizationDocumentStatus`,
      values
    );

    return result.data;
  } catch (error) {
    return [];
  }
};

export const organizationDocumentCheck = async (values) => {
  try {
    const result = await axios.post(
      `${api}/organization/organizationDocumentCheck`,
      values
    );

    return result.data;
  } catch (error) {
    return [];
  }
};

export const organizationDocumentBulkDelete = async (values) => {
  try {
    const result = await axios.post(
      `${api}/organization/organizationDocumentBulkDelete`,
      values
    );

    return result.data;
  } catch (error) {
    return [];
  }
};

export const fetchPdfDocument = async (pdfUrl) => {
  try {
    const check = await axios.get(pdfUrl);

    if (check.data && !check.data?.message) {
      const result = await axios.get(pdfUrl, {
        responseType: "arraybuffer",
      });

      return result?.data;
    } else {
      return check.data;
    }
  } catch (error) {
    const response = error?.response;

    if (response?.status === 403 || response?.status === 429) {
      const body = response?.data?.toString?.() || "";

      if (body.includes("captcha") || body.includes("verify you’re a human")) {
        throw new Error(
          "CAPTCHA challenge encountered. Please verify manually."
        );
      }
    }

    const message =
      response?.data?.message ||
      response?.statusText ||
      error.message ||
      "Unknown error while fetching PDF";

    throw new Error(message);
  }
};

export const emailOrganizationDocuments = async (formData) => {
  try {
    const result = await axios.post(`${api}/organization/emailDocuments`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message || "Failed to send email",
    };
  }
};

